import React from "react";
import { getPlayerRatingColor } from "../../../config/utils";

type PlayerRatingProps = {
  rating: number | null;
  size?: "sm" | "md" | "lg";
  showShadow?: boolean;
};

const PlayerRating: React.FC<PlayerRatingProps> = ({
  rating,
  size = "md",
  showShadow = false
}) => {
  if (rating === null) {
    return null;
  }

  const sizeClasses = {
    sm: "text-xs px-1.5 py-0.5 min-w-6",
    md: "text-sm px-2 py-0.5 min-w-7",
    lg: "text-base px-2.5 py-1 min-w-8"
  };

  const shadowClass = showShadow ? "shadow-lg" : "";

  return (
    <div
      className={`${getPlayerRatingColor(rating)} text-white font-semibold rounded-full text-center ${sizeClasses[size]} ${shadowClass}`}
    >
      {rating.toFixed(1)}
    </div>
  );
};

export default PlayerRating;

